import { useSelector } from 'react-redux';

import { selectAccountSlug } from '@/redux/session/selectors';

import { useDialogAction } from './useDialogAction';
import { useLeaveModal } from './useLeaveModal';
import { selectBrainId } from '../redux/selectors';

type DialogActionLink = { to: string; goTo: () => void };

export const useGoToDialogAction = (
  actionId?: string,
  nodeId?: string
): DialogActionLink | null => {
  const leaveModal = useLeaveModal();
  const slug = useSelector(selectAccountSlug);
  const brainId = useSelector(selectBrainId);
  const action = useDialogAction(actionId);

  if (!slug || !brainId || !action?.dialog_id) {
    return null;
  }

  const params = new URLSearchParams({
    node: nodeId ?? action.node_id,
    nodeAction: actionId as string,
  });
  const to = `/${slug}/ai-agents/${brainId}/workflows/dialogs/${action.dialog_id}?${params}`;

  return { to, goTo: () => leaveModal(to) };
};
